/* William Painter — Rx bundle cart lock
 * Prescription-lens components are added as separate cart lines sharing a hidden
 * `_rx_bundle` token. They must behave as ONE item: removing any one line removes
 * the whole bundle ("can't remove individually"), and every line stays at quantity 1
 * (a frame at qty 2 would read to the platform as two pairs on one set of lenses).
 * This runs site-wide, watches cart mutations (theme + Rebuy SmartCart both POST to
 * /cart/*), and if a bundle shrinks, clears its remaining lines; if any bundle line's
 * quantity moves off 1, sets it back to 1. Defensive + framework-agnostic.
 * See PRESCRIPTION-LENSES-ROADMAP.md and BUILD-YOUR-OWN-PAIR-ROADMAP.md.
 */
(function () {
  'use strict';
  var BUNDLE = '_rx_bundle';
  var snap = {};        // token -> line count at last check
  var busy = false;     // guard against reacting to our own cart writes
  var fixes = {};       // line key -> recent quantity-reset timestamps (backstop against a fight with another script)

  function tokens(items) {
    var m = {};
    (items || []).forEach(function (it) {
      var t = it.properties && it.properties[BUNDLE];
      if (t) { (m[t] = m[t] || []).push(it); }
    });
    return m;
  }

  function refreshUI() {
    try { document.dispatchEvent(new CustomEvent('rebuy:cart.change')); } catch (e) {}
    try { if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.fetchCart) window.Rebuy.Cart.fetchCart(); } catch (e) {}
    if (location.pathname.indexOf('/cart') === 0) location.reload();
  }

  // The Rx builder sets __rx_adding while it writes and checks a new pair; its lines are not
  // all in the cart yet, so a shrink or quantity read taken then would be wrong. Stand down.
  function adding() { return !!window.__rx_adding; }

  function reconcile() {
    if (busy || adding()) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (adding()) return; // the builder started while this read was in flight
        var cur = tokens(cart.items), updates = {}, n = 0;
        Object.keys(cur).forEach(function (t) {
          var prevN = snap[t] || 0, lines = cur[t];
          if (lines.length < prevN) {
            lines.forEach(function (it) { updates[it.key] = 0; n++; }); // a sibling was removed -> drop the rest
          } else {
            lines.forEach(function (it) { // one pair = one of each line
              if (it.quantity === 1) return;
              var now = Date.now(), recent = (fixes[it.key] || []).filter(function (ts) { return now - ts < 10000; });
              if (recent.length >= 3) return; // something keeps setting this line back; stop rather than loop
              recent.push(now); fixes[it.key] = recent;
              updates[it.key] = 1; n++;
            });
          }
        });
        var next = {}; Object.keys(cur).forEach(function (t) { next[t] = cur[t].length; });
        snap = next;
        if (n) {
          busy = true;
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
            .then(function () { busy = false; snap = {}; refreshUI(); })
            .catch(function () { busy = false; snap = {}; }); // reset snapshot so a failed reconcile can't wedge future checks
        }
      })
      .catch(function () {});
  }

  // initial snapshot
  if (document.readyState !== 'loading') reconcile();
  else document.addEventListener('DOMContentLoaded', reconcile);

  // hook cart-mutation fetches (Rebuy + theme both hit /cart/*)
  var orig = window.fetch;
  window.fetch = function () {
    var a0 = arguments[0];
    var url = (a0 && a0.url) ? a0.url : a0;
    var p = orig.apply(window, arguments);
    if (typeof url === 'string' && /\/cart\/(change|add|clear|update)(\.js|\?|$)/.test(url)) {
      p.then(function () { if (!busy) setTimeout(reconcile, 150); }).catch(function () {});
    }
    return p;
  };

  // ...and XHR, which the theme's jQuery cart code ($.ajax: drawer steppers, free gift) uses
  try {
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__rx_cart_url = String(url || ''); } catch (e) {}
      return xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        if (/\/cart\/(change|add|clear|update)(\.js|\?|$)/.test(this.__rx_cart_url || '')) {
          this.addEventListener('loadend', function () { if (!busy) setTimeout(reconcile, 150); });
        }
      } catch (e) {}
      return xSend.apply(this, arguments);
    };
  } catch (e) {}

  // and common cart events
  ['rebuy:cart.change', 'cart:updated', 'cart:refresh', 'ajaxCart:afterCartLoad'].forEach(function (ev) {
    document.addEventListener(ev, function () { if (!busy) setTimeout(reconcile, 200); });
  });
})();
